@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <label>{{ 'form.loggedInAs' | translate: { username: loggedInUser } }}</label>
        <br />
        &nbsp;
        <br />
        <label>
            {{ 'form.tenantName' | translate }}
            <input
                type="text"
                name="tenantName"
                required
                [placeholder]="'form.tenantName' | translate"
                [(ngModel)]="form.tenantName"
                validationErrors
                [minlength]="2"
                [maxlength]="255"
            />
        </label>
        <label>
            {{ 'form.sector' | translate }}
            <select name="sector" required [(ngModel)]="form.tenantTemplateId" (change)="setSelectedTemplate()">
                <option disabled [value]="undefined">{{ 'form.sector' | translate }}</option>
                @for (template of templates; track trackById($index, template)) {
                    <option [value]="template.id">
                        {{ template.label }}
                    </option>
                }
            </select>
        </label>
        @if (tenantCreationError) {
            <div class="tenant-error" @fade>{{ tenantCreationError | translate }}</div>
        }
        @if (selectedTemplate) {
            <div>
                {{ selectedTemplate.description }}
            </div>
        }
    </form>
}
